var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    className: "bob-core-components-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icons/_tint/search-"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 1)",
    className: "S\\xF8k"
  }, /*#__PURE__*/React.createElement("path", {
    className: "secondarytint",
    d: "M9.25 0a7.75 7.75 0 1 0 0 15.5 7.75 7.75 0 1 0 0-15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20c-.7.7-1.8.7-2.45 0l-3.5-3.55L16.5 14l3.5 3.55c.65.65.65 1.75 0 2.45z",
    className: "tertiarytint"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8 17.45l-3.5-3.55c.85-1.3 1.35-2.9 1.35-4.6 0-4.55-3.7-8.3-8.3-8.3C3.75 1 0 4.75 0 9.35s3.75 8.35 8.35 8.35c1.2 0 2.3-.25 3.35-.7l3.8 3.8c.45.45 1.05.7 1.65.7.6 0 1.2-.25 1.65-.7.95-.9.95-2.4 0-3.35zm-7.8-1.2c-.8.3-1.7.5-2.65.5-4.05 0-7.4-3.3-7.4-7.4 0-4.1 3.3-7.4 7.4-7.4 4.1 0 7.4 3.3 7.4 7.4 0 1.7-.55 3.25-1.55 4.5-.85 1.05-1.95 1.9-3.2 2.4zm7.15 3.9c-.25.25-.6.4-1 .4s-.75-.15-1-.4l-3.6-3.6c.8-.5 1.55-1.1 2.15-1.8l3.4 3.45c.6.5.6 1.4.05 1.95z",
    className: "primarytint"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0a41ae7de8b716b50394810b4607f7a6.svg";
export { ForwardRef as ReactComponent };